import { memo, useEffect } from 'react'

import { TJobBlock } from '../JobBlock/type'
import { useHog } from '@microfrontends/react-components'
import dynamic from 'next/dynamic'

const RecoJobsSectionSalary = dynamic(() => import('./RecommendHighSalary'))


type TProps = {
	sectionTitle?: string
	slideWrapperClass?: string[]
	noDots?: boolean
	user?: any
	userIP?: string
	langCode?: TJobBlock['langCode']
	accessToken?: string
	ctaLink?: React.ReactNode
	onDataSourceComplete?: (jobs: TJobBlock[]) => void
	jobs?: TJobBlock[]
	isMobile?: boolean
}


const RecoJobsSection = memo((props: TProps) => {
	const { ...other } = props

	const { trackingQueue } = useHog()


	useEffect(() => {
		trackingQueue({
			eventName: 'js_platform_discovery:home_page_view',
		})
	}, [props.user])

	return (
		<RecoJobsSectionSalary {...other} />
	)
})

RecoJobsSection.displayName = 'RecoJobsSection'

export default RecoJobsSection
